import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkChip from 'react/shared/components/true_link/main/TrueLinkChip';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/radios/TrueLinkRadios';
import AtmAccessInfo from 'react/signups/card/common/AtmAccessInfo';
import ErrorText from 'react/signups/card/common/ErrorText';
import triStateBooleanShape from 'react/signups/card/shapes/TriStateBoolean';

export default function CardProgramForm({ onChange, values }) {
  const options = [
    {
      label: (
        <>
          No <TrueLinkChip color="primary" label="MOST COMMON" size="small" />
        </>
      ),
      value: 'no',
    },
    {
      label: 'Yes',
      value: 'yes',
    },
  ];

  return (
    <div id="atm_access_question">
      <TrueLinkRadios
        ariaLabel="Do you need ATM access questionnaire"
        name="atmAccess"
        onChange={onChange}
        options={options}
        value={values.atmAccess}
      />
      <ErrorText name="atmAccess" />
      <AtmAccessInfo atmAccess={values.atmAccess} />
    </div>
  );
}

CardProgramForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    atmAccess: triStateBooleanShape.isRequired,
  }).isRequired,
};
